module.exports = __webpack_public_path__ + "img/aya shameimaru_lw.8b69ff9e.png";